import { ModuleRegistry } from 'ag-grid-community';

let modulesLoadPromise: Promise<void> | null = null;

export async function loadAGGridModules(): Promise<void> {
  if (modulesLoadPromise) {
    return modulesLoadPromise;
  }

  modulesLoadPromise = (async () => {
    const {
      CellStyleModule,
      ClientSideRowModelModule,
      ClientSideRowModelApiModule,
      ColumnApiModule,
      ColumnAutoSizeModule,
      ColumnHoverModule,
      CsvExportModule,
      CustomFilterModule,
      DateFilterModule,
      LargeTextEditorModule,
      NumberFilterModule,
      PaginationModule,
      RenderApiModule,
      RowApiModule,
      RowSelectionModule,
      ScrollApiModule,
      SelectEditorModule,
      TextEditorModule,
      TextFilterModule,
      ValidationModule,
      ValueCacheModule,
      RowDragModule,
      QuickFilterModule,
    } = await import('ag-grid-community');

    const {
      AdvancedFilterModule,
      ClipboardModule,
      ColumnMenuModule,
      ColumnsToolPanelModule,
      ContextMenuModule,
      ExcelExportModule,
      FiltersToolPanelModule,
      GroupFilterModule,
      MultiFilterModule,
      RichSelectModule,
      RowGroupingModule,
      RowGroupingPanelModule,
      ServerSideRowModelApiModule,
      ServerSideRowModelModule,
      SetFilterModule,
      SideBarModule,
      StatusBarModule,
      ViewportRowModelModule,
    } = await import('ag-grid-enterprise');

    ModuleRegistry.registerModules([
      ClientSideRowModelModule,
      ClientSideRowModelApiModule,
      FiltersToolPanelModule,
      ValidationModule,
      TextFilterModule,
      NumberFilterModule,
      DateFilterModule,
      SetFilterModule,
      MultiFilterModule,
      GroupFilterModule,
      CustomFilterModule,
      SideBarModule,
      StatusBarModule,
      ColumnMenuModule,
      ColumnApiModule,
      RowGroupingModule,
      RowGroupingPanelModule,
      ColumnsToolPanelModule,
      ContextMenuModule,
      ClipboardModule,
      ColumnAutoSizeModule,
      ColumnHoverModule,
      AdvancedFilterModule,
      ExcelExportModule,
      CsvExportModule,
      ValueCacheModule,
      ServerSideRowModelModule,
      ServerSideRowModelApiModule,
      ViewportRowModelModule,
      SelectEditorModule,
      TextEditorModule,
      CellStyleModule,
      RichSelectModule,
      LargeTextEditorModule,
      PaginationModule,
      RowApiModule,
      RowSelectionModule,
      RenderApiModule,
      ScrollApiModule,
      RowDragModule,
      QuickFilterModule,
    ]);
  })();

  return modulesLoadPromise;
}
